import { render, staticRenderFns } from "./SettlementRadioButton.vue?vue&type=template&id=3a6c84a4&scoped=true&"
import script from "./SettlementRadioButton.vue?vue&type=script&lang=ts&"
export * from "./SettlementRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./SettlementRadioButton.vue?vue&type=style&index=0&id=3a6c84a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c84a4",
  null
  
)

export default component.exports